import { useState, useEffect } from "react";
import { useQueryClient, useQuery } from "@tanstack/react-query";

type UseCountdownSecondProps = {
  duration: number;
  key: string;
};

export const useCountdownSecond = ({
  duration,
  key,
}: UseCountdownSecondProps) => {
  const [secondsLeft, setSecondsLeft] = useState(0);
  const queryClient = useQueryClient();

  const { data: countdownEnd = 0 } = useQuery<number>({
    queryKey: ["cooldown", key],
    queryFn: async () => 0,
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  const now = Math.floor(Date.now() / 1000);
  const initialSecondsLeft = Math.max(0, countdownEnd - now);
  const canClick = secondsLeft === 0;

  // Update secondsLeft every second
  useEffect(() => {
    setSecondsLeft(initialSecondsLeft);
    if (initialSecondsLeft === 0) return;

    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [countdownEnd]);

  const startCountdown = () => {
    const countdownUntil = Math.floor(Date.now() / 1000) + duration;
    queryClient.setQueryData(["cooldown", key], countdownUntil);
  };

  return {
    secondsLeft,
    canClick,
    startCountdown
  };
};
